import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ModalBody, ModalFooter, Button, Input, Row, Col } from 'reactstrap';
import { getSettings, updateSettings } from '../../actions/user';
import { changeLocale } from '../../actions/i18n';

const mapStateToProps = ({ user: { config }, i18n: { locales }}) => ({
  config,
  locales,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get: getSettings,
      update: updateSettings,
      change: changeLocale,
    },
    dispatch,
  );

const Settings = ({ config, locales, get, update, close, change, intl }) => {
  const [fields, setFields] = useState(config);
  const set = state => setFields({ ...fields, ...state });
  useEffect(() => {
    get();
  }, []);
  useEffect(() => {
    if (config) {
      setFields({
        ...config,
        training_reminder: config.training_reminder || 10,
        training_termination: config.training_termination || 5,
        mail_reports: config.mail_reports || 'none',
        mail_reports_direct_level: config.mail_reports_direct_level || 0,
      });
    }
  }, [config]);

  return (
    <React.Fragment>
      <ModalBody className="align-items-center">
        {fields ? (
          <React.Fragment>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_course_termination" />
              </Col>
              <Col xs="4">
                <Input
                  type="number"
                  value={fields.training_termination}
                  onChange={({ target }) =>
                    set({ training_termination: +target.value })
                  }
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_course_end" />
              </Col>
              <Col xs="4">
                <Input
                  type="number"
                  value={fields.training_reminder}
                  onChange={({ target }) =>
                    set({ training_reminder: +target.value })
                  }
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_lang" />
              </Col>
              <Col xs="4">
                <Input
                  type="select"
                  value={fields.lang}
                  onChange={({ target }) => set({ lang: target.value })}
                >
                  {locales.map(({ id, name, image }) => (
                      <option value={id} key={id}>{name}</option>
                  ))}
                </Input>
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_push_notifications" />
              </Col>
              <Col xs="4">
                <Input
                  type="checkbox"
                  onChange={() =>
                    set({ push_notifications: !fields.push_notifications })
                  }
                  checked={fields.push_notifications}
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_email_notifications" />
              </Col>
              <Col xs="4">
                <Input
                  type="checkbox"
                  onChange={() =>
                    set({ email_notifications: !fields.email_notifications })
                  }
                  checked={fields.email_notifications}
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_mail_reports" />
              </Col>
              <Col xs="4">
                <Input
                  type="select"
                  value={fields.mail_reports}
                  onChange={({ target }) => set({ mail_reports: target.value })}
                >
                  <option value="none">
                    {intl.formatMessage({ id: "settings_mail_reports_none" })}
                  </option>
                  <option value="daily">
                    {intl.formatMessage({ id: "settings_mail_reports_daily" })}
                  </option>
                  <option value="weekly">
                    {intl.formatMessage({ id: "settings_mail_reports_weekly" })}
                  </option>
                  <option value="monthly">
                    {intl.formatMessage({
                      id: "settings_mail_reports_monthly",
                    })}
                  </option>
                </Input>
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_overdue" />
              </Col>
              <Col xs="4">
                <Input
                  type="checkbox"
                  onChange={() =>
                    set({ mail_reports_overdue: !fields.mail_reports_overdue })
                  }
                  checked={fields.mail_reports_overdue}
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_in_progress" />
              </Col>
              <Col xs="4">
                <Input
                  type="checkbox"
                  onChange={() =>
                    set({
                      mail_reports_in_progress:
                        !fields.mail_reports_in_progress,
                    })
                  }
                  checked={fields.mail_reports_in_progress}
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_completed" />
              </Col>
              <Col xs="4">
                <Input
                  type="checkbox"
                  onChange={() =>
                    set({
                      mail_reports_completed: !fields.mail_reports_completed,
                    })
                  }
                  checked={fields.mail_reports_completed}
                />
              </Col>
            </Row>
            <Row style={{ paddingBottom: 5 }}>
              <Col xs="8">
                <FormattedMessage id="settings_direct_levels" />
              </Col>
              <Col xs="4">
                <Input
                  type="select"
                  value={fields.mail_reports_direct_level}
                  onChange={({ target }) =>
                    set({ mail_reports_direct_level: +target.value })
                  }
                >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                </Input>
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <div style={{ textAlign: "center" }}>
            <i className="fa fa-spin fa-spinner fa-3x" />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            update(fields);
            change(fields.lang);
            close();
          }}
        >
          <FormattedMessage id="overall_input_save" />
        </Button>
        <Button color="secondary" onClick={close}>
          <FormattedMessage id="overall_input_cancel" />
        </Button>
      </ModalFooter>
    </React.Fragment>
  );
};

Settings.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  get: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Settings));



// WEBPACK FOOTER //
// ./src/components/_Header/__settings.js